module.exports = __webpack_public_path__ + "static/img/35.337ac74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/35.jpg
// module id = SJoq
// module chunks = 0